import React, { useState, useRef, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'store'

import { Button } from 'devextreme-react/button'
import { TextBox, TextBoxRef } from 'devextreme-react/text-box'

import { DrawerState } from 'helpers/drawer-state-enum'
import { RootState } from 'slices'
import { toggleDrawer } from 'slices/ui'
import { useTranslation } from 'react-i18next'

import './drawer-menu-search.scss'

type IDrawerMenuSearchProps = {
    onSearchValueChanged: (value: string) => void,
    value: string,
    onChange: (value: any) => void,
}

export const DrawerMenuSearch = ({ onSearchValueChanged, value, onChange }: IDrawerMenuSearchProps) => {
    const dispatch = useAppDispatch()

    const [searchValue, setSearchValue] = useState('')
    const [lastState, setLastState] = useState<DrawerState | null>(null)
    const [timeoutId, setTimeoutId] = useState<any>(0)

    const { drawerState } = useSelector((state: RootState) => state.ui)
    const { t } = useTranslation()

    const searchInput = useRef<TextBoxRef>(null)

    const searchValueChanged = (e: any) => {
        setSearchValue(e.value)

        if (timeoutId) {
            clearTimeout(timeoutId)
        }

        const tId = setTimeout(() => {
            onSearchValueChanged(e.value)
            setTimeoutId(0)
        }, 400)
        setTimeoutId(tId)
    }

    const searchBtnClicked = (_: any) => {
        setLastState(drawerState)
        dispatch(toggleDrawer(DrawerState.Open))
        /* v8 ignore next 3 */
        if (searchInput && searchInput.current) {
            searchInput.current.instance && searchInput.current.instance().focus()
        }
    }

    const searchInputFocusOut = (_: any) => {
        if (lastState !== null) {
            setTimeout(() => {
                dispatch(toggleDrawer(lastState))
                setLastState(null)
            }, 700)
        }
    }

    // update local search value on external value change
    useEffect(() => {
        setSearchValue(value)
    }, [value])

    return (
        <div className='drawerMenu--search'>
            <Button
                className='drawerMenu--search-btn'
                icon='search'
                onClick={searchBtnClicked}
                hint={searchValue}
            />
            <TextBox
                ref={searchInput}
                className='drawerMenu--search-input'
                placeholder={t('global:label.enterSearchText')}
                mode='search'
                valueChangeEvent='keyup'
                onValueChanged={searchValueChanged}
                onChange={onChange}
                onFocusOut={searchInputFocusOut}
                value={searchValue}
            />
        </div>
    )
}
